import { render, staticRenderFns } from "./picCaptcha.vue?vue&type=template&id=85b14358&scoped=true&"
import script from "./picCaptcha.vue?vue&type=script&lang=js&"
export * from "./picCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./picCaptcha.vue?vue&type=style&index=0&id=85b14358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b14358",
  null
  
)

export default component.exports